/** 去除对象空值 */
const deleteEmptyObject = (object) => {
    for (var i in object) {
      if (object[i] === '' || object[i] === undefined || object[i] === null) {
        delete object[i]
      }
    }
    return object
  }
  
  /** 去除url特殊符号 **/
  const replaceURL = (url) => {
    var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%]")
    var rs = ''
    for (var i = 0; i < url.length; i++) {
      rs = rs + url.substr(i, 1).replace(pattern, '')
    }
    return rs
  }
  
  module.exports = {
    deleteEmptyObject: deleteEmptyObject,
    replaceURL: replaceURL
  }
  


// WEBPACK FOOTER //
// ./src/api/brand/utils.js